import { normalizarIdCentro } from "global/utils/idCentro";
import { getLocalStorage } from "global/utils/safeJsonParse";

// Defaults de fallback por si `config.moron` no está en el config.json o
// faltan campos. Mantenelos sincronizados con los valores que querés que
// apliquen sin un config válido.
const DEFAULTS = {
  idCentro: 3,
  circuitosBloqueados: ["KINESIO", "TOMO"],
  especialidadesBloqueadas: ["TOMOG", "KIN", "KIART", "KIATM", "P TIR"],
};

const getMoronConfig = () => {
  const config = getLocalStorage("config", {});
  const moron = config?.moron ?? {};
  return {
    idCentro: moron.idCentro ?? DEFAULTS.idCentro,
    circuitosBloqueados:
      moron.circuitosBloqueados ?? DEFAULTS.circuitosBloqueados,
    especialidadesBloqueadas:
      moron.especialidadesBloqueadas ?? DEFAULTS.especialidadesBloqueadas,
  };
};

/**
 * Devuelve los turnos del centro de Morón que no pueden recepcionarse por
 * self-service (kinesiología, tomografía, punción tiroides).
 *
 * Solo aplica si:
 *   - el centro actual es Morón, Y
 *   - el turno es de OSDE (`obra_social === "OSDE"`).
 *
 * Si alguna de esas condiciones no se cumple, retorna [].
 *
 * Configuración: lee `config.moron` desde localStorage (cargado al iniciar
 * la app desde public/config.json), con fallback a los DEFAULTS.
 *
 * @param {Array} turnos - lista de turnos del paciente.
 * @param {string|number|null} centroQR - idCentro del centro actual (terminal).
 * @returns {Array} subconjunto de `turnos` bloqueado por la regla de Morón.
 */
export const filtrarTurnosBloqueadosMoron = (turnos, centroQR) => {
  if (!Array.isArray(turnos) || turnos.length === 0) return [];

  const { idCentro, circuitosBloqueados, especialidadesBloqueadas } =
    getMoronConfig();

  if (normalizarIdCentro(centroQR) !== idCentro) return [];

  return turnos.filter((t) => {
    if (t?.obra_social !== "OSDE") return false;
    const circuito = t?.circuito;
    const idEspecialidad = t?.idEspecialidad;
    const esCircuitoBloqueado =
      circuito && circuitosBloqueados.includes(circuito);
    const esEspecialidadBloqueada =
      idEspecialidad && especialidadesBloqueadas.includes(idEspecialidad);
    return esCircuitoBloqueado || esEspecialidadBloqueada;
  });
};
